<template>
  <div class="main-content">

    <!-- Section: inner-header -->
    <section class="inner-header divider parallax layer-overlay bg-image-100-size overlay-dark-5 pt-70"
      data-parallax-ratio="0.6" data-bg-img="images/202208/Sarah07.jpg">
      <div class="container pt-100 pb-50">
        <!-- Section Content -->
        <div class="section-content pt-100">
          <div class="row">
            <div class="col-md-12">
              <h3 class="title text-white">Contatti</h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Divider: Contact -->
    <section class="divider">
      <div class="container">
        <div class="row equal">
          <div class="col-md-5">
            <img class="img-fullwidth" src="images/202208/Sarah04.jpg" alt="">
          </div>
          <div class="col-md-7">
            <h3 class="line-bottom mt-0 mb-10">Seguimi sui social</h3>
            <ul class="styled-icons icon-light icon-bordered small square list-inline mb-10">
              <li><a href="https://www.facebook.com/sarah.abdessalem" target="_blank"><i
                    class="fa fa-facebook text-gray"></i></a></li>
                    <li><a href="https://www.instagram.com/sarah_fitness_addicted/" target="_blank"><i
                    class="fa fa-instagram text-gray"></i></a></li>
                    <li><a href="https://open.spotify.com/playlist/37icozwXFtIty3lN8RTemh?si=YxKsfly3TlKkmcJD05LayA&pi=DTx-p1jLSNyee" target="_blank"><i
                    class="fa fa-spotify text-gray"></i></a></li>
            </ul>
            <h3 class="line-bottom mt-0 mb-10">Contatti</h3>

            <ul class=" mt-5">
              <li class="m-0 pl-10 pr-10"> <i class="fa fa-envelope text-theme-colored mr-5"></i> <a class="text-gray"
                  href="mailto:sarah.abdessalem@pec.it"><b>Mail PEC</b> sarah.abdessalem@pec.it</a> </li>
            </ul>

            <div v-if="!SentEmail">
              <h3 class="mt-15 mb-10 mt-sm-30">Inviami un messaggio</h3>

              <form id="contact_form" class="needs-validation" name="contact_form" @reset="resetContact" @submit="sendContact" novalidate>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Nome <small>*</small></label>
                      <input name="form_name" class="form-control" type="text" placeholder="Nome" v-model="Contact.Name"
                        required>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Email <small>*</small></label>
                      <input name="form_email" class="form-control required email" type="email" v-model="Contact.Email"
                        placeholder="Email" required>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Oggetto <small>*</small></label>
                      <input name="form_subject" class="form-control required" type="text" v-model="Contact.Subject"
                        placeholder="Oggetto" required>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Telefono</label>
                      <input name="form_phone" class="form-control" type="text" v-model="Contact.Phone"
                        placeholder="Telefono">
                    </div>
                  </div>
                </div>


                <div class="form-group">
                  <label>Messaggio <small>*</small></label>
                  <textarea name="form_message" class="form-control required" rows="5" v-model="Contact.Message"
                    placeholder="Messaggio" required></textarea>
                </div>



                <div class="row">
                  <div class="form-check col-md-12">
                    <input type="checkbox" required v-model="Contact.privacy" class="form-check-input" id="chkPrivacy" />
                    <label class="form-check-label" for="chkPrivacy">Accetto le condizioni di privacy
                      <a class="text-theme-colored" target="_blank" href="/privacy">Leggi qui</a></label>
                  </div>
                  <div class="form-check col-md-12">
                    <input type="checkbox" v-model="Contact.condition" required class="form-check-input"
                      id="chkConditions" />
                    <label class="form-check-label" for="chkConditions">Accetto i termini e condizioni
                      <a class="text-theme-colored" target="_blank" href="/terms">Leggi qui</a></label>
                  </div>
                </div>

                <div class="row pt-10">
                  <div class="alert alert-danger" v-if="error">{{ error }}</div>
                </div>

                <div class="form-group">
                  <input name="form_botcheck" class="form-control" type="hidden" value="" />
                  <button type="submit" class="btn btn-dark btn-theme-colored btn-flat mr-5"
                    data-loading-text="Please wait...">Invia messaggio</button>
                  <button type="reset" class="btn btn-default btn-flat btn-theme-colored">Svuota</button>
                </div>
              </form>
            </div>
            <div class="vertical-center t-a-center" v-if="SentEmail">
              <h3 class="mt-0 mb-10 mt-sm-30">Grazie per avermi contattata, ti risponderò il prima possibile</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.inner-header{
    background-attachment: scroll !important;
    background-position: center center !important;
    background-size: cover !important;
}

#contact_form.was-validated .form-control:invalid {
  border-color: #EE163B;
}

.form-check-input {
  margin-right: 1rem;
  width: 1.2rem;
  height: 1.2rem;
}

.vertical-center {
  top: 50%;
  position: absolute;
}

@media (min-width: 768px) {
  .row.equal {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
   
<script>
import axios from "axios";

export default {
  name: "ContactMe",
  data() {
    return {
      error: "",
      SentEmail: false,
      Contact: {
        Name: "",
        Email: "",
        Subject: "",
        Message: "",
        Phone: "",
        condition: false,
        privacy: false,
      }
    };
  },
  methods: {
    resetContact: function () {
      this.error = "";
      this.Contact = {
        Name: "",
        Email: "",
        Subject: "",
        Message: "",
        Phone: "",
        condition: false,
        privacy: false,
      };
    },
    sendContact: function () {

      this.error = "";

      if (
        !this.Contact.privacy || !this.Contact.condition) {
        this.error = "Accetta privacy e condizioni";
        return;
      }

      var form = document.getElementById('contact_form');
      if (form.checkValidity()) {


        axios.post(process.env.VUE_APP_API_URL + "/utility/contactme", this.Contact).then(response => {
          this.SentEmail = response.data.ok;
        });
      }
    }
  },
  mounted: () => {
    var form = document.getElementById('contact_form');
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      form.classList.add('was-validated');
    }, false);
  }
};
</script>